<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true">
    </loading>
    <v-row class="text-left search-bar">
      <v-col class="pt-4 pl-0 col-9 col-md-7 col-lg-5">
        <v-tabs class="tabsLeft" color="#002C61" align-with-title v-model="tab">
          <v-tabs-slider color="#002C61"></v-tabs-slider>
          <v-tab><span style="font-size:15pt; font-weight:550">修改密碼</span></v-tab>
        </v-tabs>
      </v-col>
      
      <v-col class="pr-6 pl-0 text-right col-3 col-md-5 col-lg-7">
      </v-col>
    </v-row>
    
    <v-row v-if="tab == 0" class="ma-0" id="router" style="overflow-y:scroll" :style="viewStyle">
      <div id="box" class="pa-5" style="margin-top:3%">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0" size="30" style="color:#002C61">mdi-menu-right</v-icon>
          <h4 class="DarkBlue pt-1">帳號資料</h4>
        </v-row>
        <v-row class="mx-2" justify="center">
          <v-col class="px-2 py-0 col-12 col-md-5">
            <div class="ma-0">
              <div class="text-left pt-2 pt14"><span class="start">*</span>帳號</div>
              <v-text-field class="text_field" dense outlined maxlength="50" v-model="datasets.userId"
              readonly background-color="#F4F8F9"></v-text-field>
            </div>
            <div class="ma-0">
              <div class="text-left pt-2 pt14"><span class="start">*</span>舊密碼</div>
              <v-text-field class="text_field" dense background-color="white" outlined
              :type="showOldPassword ? 'text' : 'password'" autocomplete="new-password"
              :append-icon="showOldPassword ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showOldPassword = !showOldPassword"
              placeholder="請輸入舊密碼" v-model="passwdOld"></v-text-field>
            </div>
            <div class="ma-0">
              <div class="text-left pt-2 pt14"><span class="start">*</span>新密碼</div>
              <v-text-field class="text_field" dense background-color="white" outlined
              :type="showPasswordNew ? 'text' : 'password'" autocomplete="new-password"
              :append-icon="showPasswordNew ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showPasswordNew = !showPasswordNew"
              placeholder="4~10個英文字母或數字" maxlength="10" v-model="passwdNew"></v-text-field>
            </div>
            <div class="ma-0">
              <div class="text-left pt-2 pt14"><span class="start">*</span>確認新密碼</div>
              <v-text-field class="text_field" dense background-color="white" outlined
              :type="showPasswordNewCheck ? 'text' : 'password'" autocomplete="new-password"
              :append-icon="showPasswordNewCheck ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showPasswordNewCheck = !showPasswordNewCheck"
              placeholder="4~10個英文字母或數字" maxlength="10" v-model="passwdNewCheck"></v-text-field>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-row>

    <v-footer id="footer">
      <div class="text-center mx-auto footer">
        <v-btn class="btn" large outlined color="#002C61" @click="redirectPath('/frontPage')">下次再改</v-btn>
        <v-btn class="btn" large color="#002C61" style="color: #FFF; box-shadow:none" @click="passwordChange()">修改</v-btn>
      </div>
    </v-footer>
    <ShowMsg ref="ShowMsg" :onSave="logout"/>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.min.css';
import CryptoJS from "crypto-js"
import ShowMsg from '@/dialogs/ShowMsg'

export default {
  name: 'ChangePassword',
  components: {Loading,ShowMsg},
  mounted(){
    Promise.all([
      new Promise((resolve)=>{resolve(this.isLoading = true)}),
      new Promise((resolve)=>{resolve(this.getDataset())}),
    ]).then(()=>{
      this.initDone = true
      this.isLoading = false
    })
  },
  data:() => ({
    isLoading: false,
    datasets: {},
    viewStyle: {},
    tab:0,
    initDone: false,
    passwdOld:'',
    showOldPassword: false,
    passwdNewCheck:'',
    showPasswordNewCheck: false,
    passwdNew:'',
    showPasswordNew: false,
    requiredField:['userId','passwd','userName','status'],
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{
    "recruit.identity":function(){
      this.recruit.area = ''
      this.recruit.note.splice(0)
    },
    "recruit.area":function(){
      if(this.recruit.identity == '駐點人員' && this.recruit.area){
        this.getOnsiteList()
      }
    },
  },
  computed:{
    isPasswdNewMatch() {
      return this.passwdNew == this.passwdNewCheck
    },
  },
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-199 + 'px'}
    },
    redirectPath(path){
      this.$router.push({path: path, query: {
        page: this.$route.query.page
      }})
    },
    async getDataset() {
      try {
        const request = {
          method: 'GET',
          url: '/pmMemberProfile/' + sessionStorage.getItem('manageMemberSysId'),
          params: {},
        };
        const response = await this.$http(request);
        this.datasets = response.data.data;
      } catch (e) {
        this.isLoading = false;
        this.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為CPD-7001')
      }
    },
    passwordChange(){
      if(!this.passwdOld || !this.passwdNew || !this.passwdNewCheck){
        this.$refs.ShowMsg.open(1)
        return false
      }
      if(this.passwdNew.length < 4 || this.passwdNewCheck.length < 4){
        this.$refs.ShowMsg.open(20)
        return false
      }
      if(!this.isPasswdNewMatch){
        this.$refs.ShowMsg.open(21)
        return false
      }
      if(CryptoJS.MD5(this.passwdOld).toString() != this.datasets.passwd){
        this.$refs.ShowMsg.open(22)
        return false
      }else{
        this.setDataset()
      }
    },
    setDataset(){
      this.isLoading = true
      var allData = this.$Global.copy(this.datasets)
      allData = this.$Global.jsonConcat(allData,{'updateId':sessionStorage.getItem('manageMemberUserId')})
      allData = this.$Global.jsonConcat(allData,{'passwd':CryptoJS.MD5(this.passwdNew).toString()})
      var self = this
      var request = {
        method: 'PUT',
        url: '/pmMemberProfileUpdate',
        data: self.Qs.stringify(allData)
      }
      this.$http(request).then(function(response) {
        self.$refs.ShowMsg.open(23,'','',true,true)
      }).catch(()=>{
        self.isLoading = false
        this.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為CPD-7002')
      }).finally(()=>{
        self.isLoading = false
      })
    },
    logout(){
      // remove sessionStorage
      sessionStorage.removeItem('manageMemberToken')
      sessionStorage.removeItem('manageMemberUserId')
      sessionStorage.removeItem('manageMemberName')
      sessionStorage.removeItem('manageMemberSysId')
      this.redirectPath('/login')
    },
    onShowMsg(){
      this.redirectPath('/frontPage')
    },
  }
}
</script>